<template>
  <div>
    <div class="condition-section">
      <div class="cond-row">
        <div class="item">
          <div style="margin-right: 10px">登录时间：</div>
          <DatePicker
            class="height45"
            v-model="startAtStr"
            format="yyyy-MM-dd"
            type="daterange"
            placeholder="请选择登录时间"
            style="width: 200px"
            @on-change="onTimeChange"
          ></DatePicker>
        </div>
        <div class="item">
          <Button
            class="btn-height45"
            type="primary"
            style="margin-right: 20px"
            @click="onSearch"
            >搜索</Button
          >
          <Button
            class="btn-height45"
            @click="onSearchCancel"
            style="margin-right: 20px"
            >重置</Button
          >
        </div>
      </div>
    </div>
    <div class="table-data">
      <div class="total">搜索结果（{{ total }}）</div>
      <Table
        class="domain-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="verifyStatus" slot-scope="{ row }">
          <div>
            {{ row.verifyStatus | status }}
          </div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <div v-if="row.verifyStatus != 1">
            <Button style="margin-right: 10px" @click="onReloadItem(row)"
              >重新发送认证邮件</Button
            >
            <Button @click="onDeleteItem(row)">删除</Button>
          </div>
          <div v-else>--</div>
        </template>
      </Table>
      <div class="page-tool">
        <Page
          :current="page"
          :total="total"
          :page-size="limit"
          @on-change="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { loginLogList } from "api/user.js";

export default {
  name: "myEmail",
  data() {
    return {
      startAtStr: "",
      startAt: "",
      endAt: "",
      page: 1,
      limit: 20,
      total: 0,
      columns: [
        {
          title: "序号",
          align: "center",
          type: "index",
        },
        {
          title: "登录时间",
          align: "center",
          key: "createdTime",
        },
        {
          title: "登录IP",
          align: "center",
          key: "ip",
          render: (h, { row }) => {
            return h("div", `${row.ip}-${row.address}`);
          },
        },
      ],
      data: [],
      tableLoading: false,
      addEmailModalVisibility: false,
    };
  },
  created() {
    this.req_getList();
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        let params = {
          startAt: this.startAt,
          endAt: this.endAt,
          page: this.page,
          limit: this.limit,
        };
        this.tableLoading = true;
        const { code, data } = await loginLogList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.page = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.endAt = "";
      this.startAt = "";
      this.startAtStr = "";
      this.onPageChange(1);
    },
    onTimeChange(val) {
      this.endAt = val[1];
      this.startAt = val[0];
    },
  },
};
</script>
<style lang="less" scoped>
.condition-section {
  margin: 40px 0 0;
  background-color: #fff;
  padding: 40px 20px;
  .cond-row {
    display: flex;
    flex-wrap: wrap;
    line-height: 60px;
    .item {
      display: flex;
      align-items: center;
      margin: 0 20px;
    }
  }
}
.tname {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.total {
  line-height: 80px;
  font-size: 18px;
  color: #3992e9;
  font-weight: bold;
}
.table-data {
  margin: 40px 0;
  background-color: #fff;
  padding: 20px 20px;
}
.page-tool {
  margin-top: 40px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.domain-table {
  .ivu-table-header th {
    background-color: #f0f3f6;
  }
  .ivu-table-header th,
  .ivu-table-body td {
    height: 80px;
  }
  .ivu-table-tip {
    td {
      line-height: 300px;
    }
  }
}
</style>
<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
